import LeadTime from "../../../classes/LeadTime";
import { db } from "../../../boot/firebase";
import { deleteDoc, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export const GET_LEAD_TIME = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: LeadTime,
    path: LeadTime.getPath(id),
    stateKey: "leadTimes",
    id,
  });
};

export const GET_LEAD_TIMES = (
  { dispatch },
  { where, limit, pagination } = {}
) => {
  return dispatch("GET_COLLECTION", {
    converter: LeadTime,
    stateKey: "leadTimes",
    path: LeadTime.getPath(),
    where,
    limit,
    pagination,
  });
};

export const LISTEN_LEAD_TIME = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: LeadTime,
    path: LeadTime.getPath(id),
    stateKey: "leadTimes",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_LEAD_TIMES = (
  { dispatch },
  { next, pagination, error, unlisten } = {}
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: LeadTime,
    path: LeadTime.getPath(),
    stateKey: "leadTimes",
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_LEAD_TIME = async ({ state }, { id, changes }) => {
  const ref = doc(db, LeadTime.getPath(id));
  const snapshot = await getDoc(ref);

  if (!snapshot.exists()) {
    // New Lead Time
    await setDoc(ref, {
      brand: id,
      ...changes,
      created: new Date(),
      createdBy: state.user.id,
    });
  } else {
    // Existing Lead Time
    await updateDoc(ref, {
      ...changes,
      modified: new Date(),
      modifiedBy: state.user.id,
    });
  }
  return id;
};

export const DELETE_LEAD_TIME = async ({ commit }, id) => {
  await deleteDoc(doc(db, LeadTime.getPath(id)));
  commit("REMOVE", { stateKey: "leadTimes", id });
};
